// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  eyebrow: "FindingHead__eyebrow",
  flushTop: "FindingHead__flushTop",
  head: "FindingHead__head",
  section: "FindingHead__section",
  standfirst: "FindingHead__standfirst",
  title: "FindingHead__title",
};
